import { React, useState } from 'react';
import { Icon, IconButton } from '@chakra-ui/react';
import { isSoundMuted, setSoundMuted } from './habits/rewards';

// viewBoxes are cropped to the drawn glyph (the stock 24-unit icon grid leaves
// ~a third of the box as padding, which made the icon look undersized).
const SpeakerOnIcon = (props) => (
  <Icon viewBox='2.75 4 16 16' fill='currentColor' {...props}>
    <path d='M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02z' />
  </Icon>
);

const SpeakerOffIcon = (props) => (
  <Icon viewBox='2.67 2 20 20' fill='currentColor' {...props}>
    <path d='M3 9v6h4l5 5V4L7 9H3zm13.59 .41L15.17 10.83 17.34 13l-2.17 2.17 1.42 1.42L18.76 14.41 20.93 16.59l1.41-1.42L20.17 13l2.17-2.17-1.41-1.42-2.17 2.18-2.17-2.18z' />
  </Icon>
);

/*
 * Self-contained mute control for check-in sounds; reads and writes the same
 * persisted flag the reward sounds check, so it can live anywhere in the app.
 */
function MuteToggle(props) {
  const [muted, setMuted] = useState(isSoundMuted);
  const toggle = () => {
    const next = !muted;
    setMuted(next);
    setSoundMuted(next);
  };
  return (
    <IconButton
      size='md'
      variant='ghost'
      color='gray.400'
      onClick={toggle}
      aria-label={muted ? 'Unmute check-in sounds' : 'Mute check-in sounds'}
      icon={muted ? <SpeakerOffIcon boxSize={6} /> : <SpeakerOnIcon boxSize={6} />}
      {...props}
    />
  );
}

export default MuteToggle;
